/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";

import React, { FC, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import Axios from "axios";
import {
  create,
  getAll,
  getByGroup,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { investigatorRoles } from "../../../../utils/roles";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faStar, faTrash } from "@fortawesome/free-solid-svg-icons";
import { produce } from "immer";
import { requiredInputs } from "../../../../utils/constants";
import { ROUTES } from "../../../../utils/routes";
import { useSelector } from "react-redux";
import { IStore } from "../../../../interfaces/IStore";
import { IUser } from "../../../../interfaces/IUser";
import { IEntidadParticipante } from "../../../../interfaces/IEntidadParticipante";
// import { validate } from './validations';

export const ManageEntidadParticipante: FC = () => {
  let { staffId, isAdmin, userRoleId } = useSelector(
    ({ user }: IStore) => user as IUser
  );

  const { id }: any = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { ENTIDAD_PARTICIPANTE } = paths;

  const [isCreate, setIsCreate] = useState(false);
  const [isIpUser, setIsIpUser] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  //Group form
  const [nombre, setNombre] = useState("");
 

  const [logo, setLogo] = useState();
  const [summaryEs, setSummaryEs] = useState("");
  const [summaryEn, setSummaryEn] = useState("");
  const [summaryVa, setSummaryVa] = useState("");
  const [web, setWeb] = useState("");
  const [observaciones, setObservaciones] = useState('')
  const [pais, setPais] = useState('')


  const [message, setMessage] = useState("");

  const [allowedEdit, setAllowedEdit] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    checkIfIsEdit();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const checkIfIsEdit = () => {
    const { pathname }: any = history.location;
    if (pathname.includes("crear")) {
      setIsCreate(true);
      loadDefaultData(true);
    } else {
      loadDefaultData(false);
      setIsCreate(false);
    }
  };

  const loadDefaultData = async (isCreate: boolean) => {
    try {
     

      if (isMountedRef.current) {
        
        if (!isCreate) {
          loadEntidadParticipante();
        } else setAllowedEdit(true);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const loadEntidadParticipante = async () => {
    try {
      const {
       nombre,
        staff,
        summaryEs,
        summaryEn,
        summaryVa,
        web,
        observaciones,
        pais,
        logo,
      } = await getById(ENTIDAD_PARTICIPANTE, id, source);

      if (isMountedRef.current) {
        setNombre(nombre);
      
        setSummaryEs(summaryEs);
        setSummaryEn(summaryEn);
        setSummaryVa(summaryVa);
        setWeb(web);
        setObservaciones(observaciones)
        setPais(pais)
        setLogo(logo);
   

        setAllowedEdit(true);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };


  const handleSubmit = () => {    
    const entidadParticipante: IEntidadParticipante = buildEntidadParticipante();
    //  const notValid = validate(entidadParticipante);
    // 	if (notValid) {
    // 		setMessage(notValid);
    // 		setTimeout(() => setMessage(''), 4000);
    // 		return;
    // 	}

    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({ 
      icon: "question",
      text: `¿Quieres ${question} entidad participante?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleConfirmation(entidadParticipante, logo);
    });
  };

  const handleConfirmation = (
    entidadParticipante: IEntidadParticipante,
    logo: any
  ) => {
    let createOrUpdate = isCreate
      ? create(ENTIDAD_PARTICIPANTE, entidadParticipante, source)
      : update(ENTIDAD_PARTICIPANTE, id, entidadParticipante, source);
    createOrUpdate
      .then(async ({ id: entidadParticipanteId }) => {
        let createOrUpdateText = isCreate ? "creada" : "editada";
        Swal.fire({
          icon: "success",
          text: `Entidad ${createOrUpdateText} correctamente.`,
        });
        if (typeof logo !== "string") {
          const formData = new FormData();
          formData.append("image", logo!);
          await saveFile(
            ENTIDAD_PARTICIPANTE,
            entidadParticipanteId,
            "logo",
            formData,
            source
          );
        }
        history.push(
          `${ROUTES.EntidadesParticipantes.all}/${entidadParticipanteId}`
        );
        isMountedRef.current && setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const buildEntidadParticipante = () => ({  
    nombre,  
    summaryEs,
    summaryEn,
    summaryVa,
    web,
    observaciones,
    pais,
    

   
  });

 
  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Entidad participante
        </button>
      );
    }
    //if is update && logged user included as IP
    if (!isCreate || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() =>
              deleteIt(
                ENTIDAD_PARTICIPANTE,
                id,
                ROUTES.EntidadesParticipantes.all,
                source
              )
            }
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

  return (
    <div className="centerPage">
      {(isAdmin || userRoleId === 2) && (
        <>
          {" "}
          <div className="container-fluid ">
            <div className="row">
              <div className="col d-flex justify-content-between">
                <div>
                  <h3>Entidad Participante</h3>
                </div>
                <div>{editDeleteButtons()}</div>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className="form-row mt-2  d-flex flex-start">
            <div className="col-6 d-flex justify-content-center">
              <FileUploader handleFile={setLogo} image={logo} />
            </div>
            <div className="col-6  d-flex flex-column  justify-content-center ">
              <small>*Nombre</small>
              <input
                type="text"
                className="form-control"
                placeholder="Nombre"
                value={nombre}
                onChange={({ target: { value } }) => {
                  setNombre(value);
                }}
                disabled={!allowedEdit}
              />
            </div>
          </div>
          <div>
            <div className="form-row mt-2">
              <div className="col">
                <small>Url web</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Url web"
                  value={web}
                  onChange={({ target: { value } }) => {
                    setWeb(value);
                  }}
                  disabled={!allowedEdit}
                />
              </div>
              <div className="col">
                <small>Observaciones</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Observaciones"
                  value={observaciones}
                  onChange={({ target: { value } }) => {
                    setObservaciones(value);
                  }}
                  disabled={!allowedEdit}
                />
              </div>
              <div className="col">
                <small>País</small>
                <input
                  type="text"
                  className="form-control"
                  placeholder="País"
                  value={pais}
                  onChange={({ target: { value } }) => {
                    setPais(value);
                  }}
                  disabled={!allowedEdit}
                />
              </div>
            </div>
          </div>
          
          {(isCreate || allowedEdit) && (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>*Descripción en español</small>
                  <CKEditor
                    initData={summaryEs}
                    config={editorConfig}
                    onChange={({ editor }: { editor: any }) =>
                      setSummaryEs(editor.getData())
                    }
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>

              <div className="form-row mt-4">
                <div className="col">
                  <small>*Descripción en inglés</small>
                  <CKEditor
                    initData={summaryEn}
                    config={editorConfig}
                    onChange={({ editor }: { editor: any }) =>
                      setSummaryEn(editor.getData())
                    }
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>*Descripción en valencianos</small>
                  <CKEditor
                    initData={summaryVa}
                    config={editorConfig}
                    onChange={({ editor }: { editor: any }) =>
                      setSummaryVa(editor.getData())
                    }
                    readOnly={!allowedEdit}
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};
